import React from 'react';
import { useMsal } from '@azure/msal-react';
import { Navigate } from 'react-router-dom';
import { InteractionStatus } from '@azure/msal-browser';
import { getEmbedHomePath } from '../../../helpers/embedMode';
import { hasPartnerSession } from '../../../services/partnerSession';
import Loading from '../Loading/Loading';

interface PrivateRouteProps {
  element: React.ReactElement;
}

// A partner iframe (MixVoIP) session has no MSAL account, so MSAL alone
// can't say whether this tab is signed in.
const isAuthenticated = (accounts: any[]) => {
  return accounts.length > 0 || hasPartnerSession();
};

const PrivateRoute: React.FC<PrivateRouteProps> = ({ element }) => {
  const { accounts, inProgress } = useMsal();

  if (
    inProgress === InteractionStatus.HandleRedirect ||
    inProgress === InteractionStatus.Login ||
    inProgress === InteractionStatus.AcquireToken
  ) {
    return <Loading />;
  }

  return isAuthenticated(accounts) ? (
    element
  ) : (
    <Navigate to={getEmbedHomePath()} />
  );
};

export default PrivateRoute;
